import { nft } from './index'

// 공통 필터 메서드 적용 
import { checkLimitedUser } from './function/method'

function fetchMiningInfo () {
  return nft.post('autoMiningInfo.do', {
    userKey: sessionStorage.getItem('userKey')
  }).then((res) => {
    return checkLimitedUser(res)
  });
}

function setAutoMining (option) {
  return nft.post('setAutoMining.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function buyNftRequest (option) {
  return nft.post('buyNftRequest.do',option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchBuyNftReqList () {
  return nft.post('buyNftReqList.do', {
    userKey: sessionStorage.getItem('userKey')
  }).then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchBuyInfo () {
  return nft.post('buyInfo.do', {
    userKey: sessionStorage.getItem('userKey')
  }).then((res) => {
    return checkLimitedUser(res)
  });
}
/*
function fetchPointList () {
  return nft.post('pointList.do', {
    userKey: sessionStorage.getItem('userKey')
  }).then((res) => {
    return checkLimitedUser(res)
  });
}
*/
function fetchPointList (option) {
  return nft.post('pointList.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

export { fetchMiningInfo, setAutoMining, buyNftRequest, fetchBuyNftReqList, fetchBuyInfo , fetchPointList }